import FrontLayoutMain from "../components/frontLayout/main";

import FrontHome from "../page/front/home";
import FrontChooseForm from "../page/front/chooseForm";
import FrontBasicForm from "../page/front/basicForm";
import FrontStepForm from "../page/front/stepForm";

const routes = [
  {
    path: "",
    element: <FrontLayoutMain />,
    children: [
      {
        path: "",
        element: <FrontHome />,
      },
      {
        path: "chooseForm",
        element: <FrontChooseForm />,
      },
      {
        path: "basicForm",
        element: <FrontBasicForm />,
      },
      {
        path: "stepForm",
        element: <FrontStepForm />,
      },
      {
        path: "*",
        element: <>無畫面</>,
      },
    ],
  },
];

export default {
  routes,
};
